import React from 'react';
import TextField from '@material-ui/core/TextField';
// import { withStyles } from "@material-ui/core/styles";
// import InputBase from "@material-ui/core/InputBase";

import './_InputText.scss';

function InputText(props) {
    let mod_class = ['InputText'];
    mod_class = mod_class.join(' ');

    return (
        <div className={mod_class}>
            <TextField
                id={props.id}
                label={props.label}
                type={props.type}
                name={props.id}
                error={props.error}
                required={props.required}
                autoComplete={props.autoComplete}
                variant="outlined"
                onChange={props.onChange}
                helperText={props.helperText}
                defaultValue={props.defaultValue}
                onBlur={props.onBlur}
            />
        </div>
    );
}

export default InputText;
